var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "content"
  }, [_c('p', {
    staticClass: "text-body-2 grey--text text--darken-1 mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$translate("modalIntro")) + " ")]), _vm.isSystemReadonly ? _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("systemFormatReadonly")) + " ")]) : _vm.isSystem ? _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("systemFormatEditableByAdmin")) + " ")]) : _vm._e(), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$translate('fieldLabelSingular'),
      "counter": "128",
      "maxlength": "128",
      "required": "",
      "autofocus": "",
      "disabled": _vm.isSystemReadonly,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.label_singular,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "label_singular", $$v);
      },
      expression: "form.label_singular"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$translate('fieldLabelPlural'),
      "counter": "128",
      "maxlength": "128",
      "required": "",
      "disabled": _vm.isSystemReadonly,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.label_plural,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "label_plural", $$v);
      },
      expression: "form.label_plural"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.form.content_quantity,
      "label": _vm.$translate('fieldContentQuantity'),
      "type": "text",
      "inputmode": "decimal",
      "disabled": _vm.isSystemReadonly,
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function input($event) {
        _vm.form.content_quantity = _vm.$utils.normalizeDecimalString($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate('fieldContentQuantity')))]), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('fieldContentQuantityHint')
          }
        })];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.unitChoices,
      "label": _vm.$translate('fieldContentUnit'),
      "disabled": _vm.isSystemReadonly,
      "outlined": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate('fieldContentUnit')))]), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('fieldContentUnitHint')
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.content_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content_unit", $$v);
      },
      expression: "form.content_unit"
    }
  })], 1)], 1)], 1), _c('template', {
    slot: "bottom"
  }, [_c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancelClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("cancel")) + " ")]), !_vm.isSystemReadonly ? _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "color": "primary",
      "loading": _vm.saving,
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.saveClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("save")) + " ")]) : _vm._e()], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }